import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAppContext } from "../libs/contextLib";

//Representa una ruta que requiere autenticación, si no la tiene, redirige al login
export default function AuthenticatedRoute({ children, ...rest }) {
  //const { pathname, search } = useLocation();
  const { isAuthenticated } = useAppContext();
  return (
    <Route {...rest}>
      {isAuthenticated ? (
        children
      ) : (
        <Redirect to={
          `/login`
        } />
      )}
    </Route>
  );
}
